import { action } from "../../../utils/actions";

export const OPEN_TRANSLATIONS_LIST = action("OPEN_TRANSLATIONS_LIST");
export const GET_TRANSLATIONS = action("GET_TRANSLATIONS");
export const OPEN_EMAIL_TRANSLATIONS_LIST = action(
  "OPEN_EMAIL_TRANSLATIONS_LIST",
);
export const GET_EMAIL_TRANSLATIONS = action("GET_EMAIL_TRANSLATIONS");
export const OPEN_SMS_TRANSLATIONS_LIST = action("OPEN_SMS_TRANSLATIONS_LIST");
export const GET_SMS_TRANSLATIONS = action("GET_SMS_TRANSLATIONS");
